














 
















































































































































































































































































































const node = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "fieldName",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "authToken",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "concreteType": "StandardMutationError",
  "kind": "LinkedField",
  "name": "error",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "message",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "meetingId",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v5 = [
  (v4/*: any*/)
],
v6 = {
  "alias": null,
  "args": null,
  "concreteType": null,
  "kind": "LinkedField",
  "name": "activeMeetings",
  "plural": true,
  "selections": (v5/*: any*/),
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isPaid",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "type",
  "storageKey": null
},
v11 = {
  "args": null,
  "kind": "FragmentSpread",
  "name": "DiscussionMentioned_notification"
},
v12 = {
  "args": null,
  "kind": "FragmentSpread",
  "name": "KickedOut_notification"
},
v13 = {
  "args": null,
  "kind": "FragmentSpread",
  "name": "PaymentRejected_notification"
},
v14 = {
  "args": null,
  "kind": "FragmentSpread",
  "name": "TaskInvolves_notification"
},
v15 = {
  "args": null,
  "kind": "FragmentSpread",
  "name": "PromoteToBillingLeader_notification"
},
v16 = {
  "args": null,
  "kind": "FragmentSpread",
  "name": "TeamArchived_notification"
},
v17 = {
  "args": null,
  "kind": "FragmentSpread",
  "name": "TeamInvitationNotification_notification"
},
v18 = {
  "args": null,
  "kind": "FragmentSpread",
  "name": "MeetingStageTimeLimitEnd_notification"
},
v19 = {
  "args": null,
  "kind": "FragmentSpread",
  "name": "ResponseMentioned_notification"
},
v20 = {
  "args": null,
  "kind": "FragmentSpread",
  "name": "Mentioned_notification"
},
v21 = {
  "args": null,
  "kind": "FragmentSpread",
  "name": "ResponseReplied_notification"
},
v22 = {
  "args": null,
  "kind": "FragmentSpread",
  "name": "TeamsLimitExceededNotification_notification"
},
v23 = {
  "args": null,
  "kind": "FragmentSpread",
  "name": "TeamsLimitReminderNotification_notification"
},
v24 = {
  "args": null,
  "kind": "FragmentSpread",
  "name": "PromptToJoinOrgNotification_notification"
},
v25 = {
  "args": null,
  "kind": "FragmentSpread",
  "name": "RequestToJoinOrgNotification_notification"
},
v26 = {
  "args": null,
  "kind": "FragmentSpread",
  "name": "KudosReceivedNotification_notification"
},
v27 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "preferredName",
  "storageKey": null
},
v28 = {
  "alias": null,
  "args": null,
  "concreteType": "User",
  "kind": "LinkedField",
  "name": "author",
  "plural": false,
  "selections": [
    (v4/*: any*/),
    (v27/*: any*/)
  ],
  "storageKey": null
},
v29 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "phaseType",
  "storageKey": null
},
v30 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "facilitatorStageId",
  "storageKey": null
},
v31 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isComplete",
  "storageKey": null
},
v32 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isNavigable",
  "storageKey": null
},
v33 = {
  "alias": null,
  "args": null,
  "concreteType": "TeamPromptResponse",
  "kind": "LinkedField",
  "name": "response",
  "plural": false,
  "selections": (v5/*: any*/),
  "storageKey": null
},
v34 = {
  "alias": null,
  "args": null,
  "concreteType": null,
  "kind": "LinkedField",
  "name": "stage",
  "plural": false,
  "selections": [
    (v9/*: any*/),
    (v4/*: any*/),
    {
      "kind": "InlineFragment",
      "selections": [
        (v33/*: any*/)
      ],
      "type": "TeamPromptResponseStage",
      "abstractKey": null
    }
  ],
  "storageKey": null
},
v35 = [
  (v27/*: any*/)
],
v36 = [
  (v4/*: any*/),
  (v7/*: any*/)
],
v37 = {
  "alias": null,
  "args": null,
  "concreteType": "TeamPromptMeeting",
  "kind": "LinkedField",
  "name": "meeting",
  "plural": false,
  "selections": (v36/*: any*/),
  "storageKey": null
},
v38 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "kudosEmojiUnicode",
  "storageKey": null
},
v39 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "senderName",
  "storageKey": null
},
v40 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "meetingName",
  "storageKey": null
},
v41 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "content",
  "storageKey": null
},
v42 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "retroDiscussStageIdx",
  "storageKey": null
},
v43 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "orgName",
  "storageKey": null
},
v44 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "scheduledLockAt",
  "storageKey": null
},
v45 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "orgId",
  "storageKey": null
},
v46 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "activeDomain",
  "storageKey": null
},
v47 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "email",
  "storageKey": null
},
v48 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "picture",
  "storageKey": null
},
v49 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "domainJoinRequestId",
  "storageKey": null
},
v50 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "emojiUnicode",
  "storageKey": null
},
v51 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "status",
  "storageKey": null
},
v52 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "queryString",
  "storageKey": null
},
v53 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isJQL",
  "storageKey": null
},
v54 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "projectKeyFilters",
  "storageKey": null
},
v55 = {
  "alias": null,
  "args": null,
  "concreteType": "JiraSearchQuery",
  "kind": "LinkedField",
  "name": "searchQueries",
  "plural": true,
  "selections": [
    (v4/*: any*/),
    (v52/*: any*/),
    (v53/*: any*/),
    (v54/*: any*/)
  ],
  "storageKey": null
},
v56 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "lastUsedAt",
  "storageKey": null
},
v57 = {
  "alias": null,
  "args": null,
  "concreteType": "GitHubSearchQuery",
  "kind": "LinkedField",
  "name": "githubSearchQueries",
  "plural": true,
  "selections": [
    (v4/*: any*/),
    (v52/*: any*/),
    (v56/*: any*/)
  ],
  "storageKey": null
},
v58 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "removedSuggestedActionId",
    "storageKey": null
  }
],
v59 = {
  "alias": null,
  "args": null,
  "concreteType": "AddOrgPayload",
  "kind": "LinkedField",
  "name": "AddOrgPayload",
  "plural": false,
  "selections": (v58/*: any*/),
  "storageKey": null
},
v60 = {
  "alias": null,
  "args": null,
  "concreteType": "AddTeamPayload",
  "kind": "LinkedField",
  "name": "AddTeamPayload",
  "plural": false,
  "selections": (v58/*: any*/),
  "storageKey": null
},
v61 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isActive",
  "storageKey": null
},
v62 = {
  "alias": null,
  "args": null,
  "concreteType": "Team",
  "kind": "LinkedField",
  "name": "team",
  "plural": false,
  "selections": (v36/*: any*/),
  "storageKey": null
},
v63 = [
  (v48/*: any*/),
  (v27/*: any*/)
],
v64 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "involvement",
  "storageKey": null
},
v65 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "tags",
  "storageKey": null
},
v66 = {
  "alias": null,
  "args": null,
  "concreteType": "EndCheckInSuccess",
  "kind": "LinkedField",
  "name": "EndCheckInSuccess",
  "plural": false,
  "selections": (v58/*: any*/),
  "storageKey": null
},
v67 = {
  "alias": null,
  "args": null,
  "concreteType": "EndRetrospectiveSuccess",
  "kind": "LinkedField",
  "name": "EndRetrospectiveSuccess",
  "plural": false,
  "selections": (v58/*: any*/),
  "storageKey": null
},
v68 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "token",
  "storageKey": null
},
v69 = {
  "alias": null,
  "args": null,
  "concreteType": "Organization",
  "kind": "LinkedField",
  "name": "organization",
  "plural": false,
  "selections": (v36/*: any*/),
  "storageKey": null
},
v70 = {
  "alias": null,
  "args": null,
  "concreteType": "InvalidateSessionsPayload",
  "kind": "LinkedField",
  "name": "InvalidateSessionsPayload",
  "plural": false,
  "selections": [
    (v1/*: any*/)
  ],
  "storageKey": null
},
v71 = {
  "alias": null,
  "args": null,
  "concreteType": "JiraSearchQuery",
  "kind": "LinkedField",
  "name": "jiraSearchQueries",
  "plural": true,
  "selections": [
    (v4/*: any*/),
    (v52/*: any*/),
    (v53/*: any*/),
    (v54/*: any*/),
    (v56/*: any*/)
  ],
  "storageKey": null
},
v72 = {
  "alias": null,
  "args": null,
  "concreteType": "IntegrationProviderOAuth1",
  "kind": "LinkedField",
  "name": "sharedProviders",
  "plural": true,
  "selections": (v5/*: any*/),
  "storageKey": null
},
v73 = {
  "alias": null,
  "args": null,
  "concreteType": "AuthTokenPayload",
  "kind": "LinkedField",
  "name": "AuthTokenPayload",
  "plural": false,
  "selections": (v5/*: any*/),
  "storageKey": null
},
v74 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isConnected",
  "storageKey": null
},
v75 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "lastSeenAt",
  "storageKey": null
},
v76 = {
  "alias": null,
  "args": null,
  "concreteType": "User",
  "kind": "LinkedField",
  "name": "User",
  "plural": false,
  "selections": [
    (v4/*: any*/),
    (v74/*: any*/),
    (v75/*: any*/)
  ],
  "storageKey": null
},
v77 = {
  "alias": null,
  "args": null,
  "concreteType": "DisconnectSocketPayload",
  "kind": "LinkedField",
  "name": "DisconnectSocketPayload",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "User",
      "kind": "LinkedField",
      "name": "user",
      "plural": false,
      "selections": [
        (v4/*: any*/),
        (v74/*: any*/)
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v78 = {
  "alias": null,
  "args": null,
  "concreteType": "UpdateFeatureFlagPayload",
  "kind": "LinkedField",
  "name": "UpdateFeatureFlagPayload",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "User",
      "kind": "LinkedField",
      "name": "user",
      "plural": false,
      "selections": (v5/*: any*/),
      "storageKey": null
    }
  ],
  "storageKey": null
},
v79 = {
  "alias": null,
  "args": null,
  "concreteType": "AddNewFeaturePayload",
  "kind": "LinkedField",
  "name": "AddNewFeaturePayload",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "NewFeatureBroadcast",
      "kind": "LinkedField",
      "name": "newFeature",
      "plural": false,
      "selections": [
        (v4/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "actionButtonCopy",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "snackbarMessage",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "url",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v80 = {
  "alias": null,
  "args": null,
  "concreteType": "JiraIssue",
  "kind": "LinkedField",
  "name": "JiraIssue",
  "plural": false,
  "selections": [
    (v4/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "summary",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "descriptionHTML",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v81 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "createdAt",
  "storageKey": null
},
v82 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "teamId",
  "storageKey": null
},
v83 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isViewerOnTeam",
  "storageKey": null
},
v84 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "lockedAt",
  "storageKey": null
},
v85 = [
  (v4/*: any*/),
  (v8/*: any*/),
  (v7/*: any*/),
  (v83/*: any*/),
  {
    "alias": null,
    "args": null,
    "concreteType": "Organization",
    "kind": "LinkedField",
    "name": "organization",
    "plural": false,
    "selections": [
      (v4/*: any*/),
      (v7/*: any*/),
      (v84/*: any*/)
    ],
    "storageKey": null
  }
],
v86 = [
  (v9/*: any*/),
  (v4/*: any*/)
],
v87 = [
  (v62/*: any*/)
],
v88 = {
  "kind": "TypeDiscriminator",
  "abstractKey": "__isNotification"
},
v89 = [
  (v48/*: any*/),
  (v27/*: any*/),
  (v4/*: any*/)
],
v90 = {
  "alias": null,
  "args": null,
  "concreteType": "User",
  "kind": "LinkedField",
  "name": "author",
  "plural": false,
  "selections": (v89/*: any*/),
  "storageKey": null
},
v91 = [
  (v41/*: any*/),
  (v4/*: any*/)
],
v92 = {
  "alias": null,
  "args": null,
  "concreteType": "Comment",
  "kind": "LinkedField",
  "name": "comment",
  "plural": false,
  "selections": (v91/*: any*/),
  "storageKey": null
},
v93 = {
  "alias": null,
  "args": null,
  "concreteType": "Discussion",
  "kind": "LinkedField",
  "name": "discussion",
  "plural": false,
  "selections": [
    (v34/*: any*/),
    (v4/*: any*/)
  ],
  "storageKey": null
},
v94 = {
  "kind": "InlineFragment",
  "selections": [
    (v81/*: any*/),
    (v51/*: any*/)
  ],
  "type": "Notification",
  "abstractKey": "__isNotification"
},
v95 = {
  "alias": null,
  "args": null,
  "concreteType": "User",
  "kind": "LinkedField",
  "name": "evictor",
  "plural": false,
  "selections": (v89/*: any*/),
  "storageKey": null
},
v96 = {
  "alias": null,
  "args": null,
  "concreteType": "Team",
  "kind": "LinkedField",
  "name": "team",
  "plural": false,
  "selections": [
    (v7/*: any*/),
    (v4/*: any*/)
  ],
  "storageKey": null
},
v97 = {
  "alias": null,
  "args": null,
  "concreteType": "CreditCard",
  "kind": "LinkedField",
  "name": "creditCard",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "last4",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "brand",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v98 = {
  "alias": null,
  "args": null,
  "concreteType": "Organization",
  "kind": "LinkedField",
  "name": "organization",
  "plural": false,
  "selections": [
    (v4/*: any*/),
    (v97/*: any*/)
  ],
  "storageKey": null
},
v99 = {
  "alias": null,
  "args": null,
  "concreteType": "TeamMember",
  "kind": "LinkedField",
  "name": "changeAuthor",
  "plural": false,
  "selections": (v89/*: any*/),
  "storageKey": null
},
v100 = {
  "alias": null,
  "args": null,
  "concreteType": "User",
  "kind": "LinkedField",
  "name": "user",
  "plural": false,
  "selections": (v89/*: any*/),
  "storageKey": null
},
v101 = {
  "alias": null,
  "args": null,
  "concreteType": "Task",
  "kind": "LinkedField",
  "name": "task",
  "plural": false,
  "selections": [
    (v4/*: any*/),
    (v41/*: any*/),
    (v51/*: any*/),
    (v65/*: any*/),
    (v100/*: any*/)
  ],
  "storageKey": null
},
v102 = {
  "kind": "InlineFragment",
  "selections": [
    (v81/*: any*/)
  ],
  "type": "Notification",
  "abstractKey": "__isNotification"
},
v103 = {
  "alias": null,
  "args": null,
  "concreteType": "Organization",
  "kind": "LinkedField",
  "name": "organization",
  "plural": false,
  "selections": [
    (v4/*: any*/),
    (v7/*: any*/),
    (v48/*: any*/)
  ],
  "storageKey": null
},
v104 = {
  "alias": null,
  "args": null,
  "concreteType": "User",
  "kind": "LinkedField",
  "name": "archivor",
  "plural": false,
  "selections": (v89/*: any*/),
  "storageKey": null
},
v105 = {
  "alias": null,
  "args": null,
  "concreteType": "TeamInvitation",
  "kind": "LinkedField",
  "name": "invitation",
  "plural": false,
  "selections": [
    (v68/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "User",
      "kind": "LinkedField",
      "name": "inviter",
      "plural": false,
      "selections": (v89/*: any*/),
      "storageKey": null
    },
    (v4/*: any*/)
  ],
  "storageKey": null
},
v106 = {
  "alias": null,
  "args": null,
  "concreteType": null,
  "kind": "LinkedField",
  "name": "meeting",
  "plural": false,
  "selections": [
    (v9/*: any*/),
    (v4/*: any*/),
    (v7/*: any*/),
    (v96/*: any*/)
  ],
  "storageKey": null
},
v107 = {
  "alias": null,
  "args": null,
  "concreteType": "TeamPromptResponse",
  "kind": "LinkedField",
  "name": "response",
  "plural": false,
  "selections": [
    (v4/*: any*/),
    (v100/*: any*/)
  ],
  "storageKey": null
},
v108 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "senderPicture",
  "storageKey": null
},
v109 = {
  "alias": null,
  "args": null,
  "concreteType": "RetroReflection",
  "kind": "LinkedField",
  "name": "retroReflection",
  "plural": false,
  "selections": (v91/*: any*/),
  "storageKey": null
},
v110 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "orgPicture",
  "storageKey": null
},
v111 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "requestCreatedBy",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "NotificationSubscription",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "NotificationSubscriptionPayload",
        "kind": "LinkedField",
        "name": "notificationSubscription",
        "plural": false,
        "selections": [
          (v0/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "AcceptTeamInvitationPayload",
            "kind": "LinkedField",
            "name": "AcceptTeamInvitationPayload",
            "plural": false,
            "selections": [
              (v1/*: any*/),
              (v2/*: any*/),
              (v3/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "Team",
                "kind": "LinkedField",
                "name": "team",
                "plural": false,
                "selections": [
                  (v4/*: any*/),
                  (v6/*: any*/),
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "DashNavListTeam"
                  },
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "MeetingsDashActiveMeetings"
                  },
                  (v7/*: any*/),
                  (v8/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Organization",
                    "kind": "LinkedField",
                    "name": "organization",
                    "plural": false,
                    "selections": [
                      (v4/*: any*/),
                      (v7/*: any*/),
                      {
                        "args": null,
                        "kind": "FragmentSpread",
                        "name": "DashNavList_organization"
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "PublicTeamsFrag_team"
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "meeting",
                "plural": false,
                "selections": [
                  (v4/*: any*/),
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "MeetingSeries",
                        "kind": "LinkedField",
                        "name": "meetingSeries",
                        "plural": false,
                        "selections": [
                          (v4/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": null,
                            "kind": "LinkedField",
                            "name": "mostRecentMeeting",
                            "plural": false,
                            "selections": (v5/*: any*/),
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "type": "TeamPromptMeeting",
                    "abstractKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "TeamMember",
                "kind": "LinkedField",
                "name": "teamMember",
                "plural": false,
                "selections": [
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "DashboardAvatar_teamMember"
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "User",
                "kind": "LinkedField",
                "name": "teamLead",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "suggestedActions",
                    "plural": true,
                    "selections": [
                      (v9/*: any*/),
                      {
                        "args": null,
                        "kind": "FragmentSpread",
                        "name": "SuggestedActionInviteYourTeam_suggestedAction"
                      },
                      {
                        "args": null,
                        "kind": "FragmentSpread",
                        "name": "SuggestedActionTryTheDemo_suggestedAction"
                      },
                      {
                        "args": null,
                        "kind": "FragmentSpread",
                        "name": "SuggestedActionTryRetroMeeting_suggestedAction"
                      },
                      {
                        "args": null,
                        "kind": "FragmentSpread",
                        "name": "SuggestedActionTryActionMeeting_suggestedAction"
                      },
                      {
                        "args": null,
                        "kind": "FragmentSpread",
                        "name": "SuggestedActionCreateNewTeam_suggestedAction"
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "AddedNotification",
            "kind": "LinkedField",
            "name": "AddedNotification",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "addedNotification",
                "plural": false,
                "selections": [
                  (v10/*: any*/),
                  (v4/*: any*/),
                  (v11/*: any*/),
                  (v12/*: any*/),
                  (v13/*: any*/),
                  (v14/*: any*/),
                  (v15/*: any*/),
                  (v16/*: any*/),
                  (v17/*: any*/),
                  (v18/*: any*/),
                  (v19/*: any*/),
                  (v20/*: any*/),
                  (v21/*: any*/),
                  (v22/*: any*/),
                  (v23/*: any*/),
                  (v24/*: any*/),
                  (v25/*: any*/),
                  (v26/*: any*/),
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v28/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "TeamPromptMeeting",
                        "kind": "LinkedField",
                        "name": "meeting",
                        "plural": false,
                        "selections": [
                          (v4/*: any*/),
                          (v7/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": null,
                            "kind": "LinkedField",
                            "name": "phases",
                            "plural": true,
                            "selections": [
                              (v29/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": null,
                                "kind": "LinkedField",
                                "name": "stages",
                                "plural": true,
                                "selections": (v5/*: any*/),
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          },
                          {
                            "kind": "InlineDataFragmentSpread",
                            "name": "fromStageIdToUrl_meeting",
                            "selections": [
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  (v4/*: any*/),
                                  (v30/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": null,
                                    "kind": "LinkedField",
                                    "name": "phases",
                                    "plural": true,
                                    "selections": [
                                      (v29/*: any*/),
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": null,
                                        "kind": "LinkedField",
                                        "name": "stages",
                                        "plural": true,
                                        "selections": [
                                          (v4/*: any*/),
                                          (v31/*: any*/),
                                          (v32/*: any*/)
                                        ],
                                        "storageKey": null
                                      }
                                    ],
                                    "storageKey": null
                                  }
                                ],
                                "type": "NewMeeting",
                                "abstractKey": "__isNewMeeting"
                              }
                            ],
                            "args": null,
                            "argumentDefinitions": []
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Discussion",
                        "kind": "LinkedField",
                        "name": "discussion",
                        "plural": false,
                        "selections": [
                          (v4/*: any*/),
                          (v34/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "type": "NotifyDiscussionMentioned",
                    "abstractKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "TeamPromptResponse",
                        "kind": "LinkedField",
                        "name": "response",
                        "plural": false,
                        "selections": [
                          (v4/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "User",
                            "kind": "LinkedField",
                            "name": "user",
                            "plural": false,
                            "selections": (v35/*: any*/),
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      (v37/*: any*/),
                      (v38/*: any*/)
                    ],
                    "type": "NotifyResponseMentioned",
                    "abstractKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v38/*: any*/),
                      (v39/*: any*/),
                      (v3/*: any*/),
                      (v40/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "RetroReflection",
                        "kind": "LinkedField",
                        "name": "retroReflection",
                        "plural": false,
                        "selections": [
                          (v41/*: any*/)
                        ],
                        "storageKey": null
                      },
                      (v42/*: any*/)
                    ],
                    "type": "NotifyMentioned",
                    "abstractKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v28/*: any*/),
                      (v33/*: any*/),
                      (v37/*: any*/)
                    ],
                    "type": "NotifyResponseReplied",
                    "abstractKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v43/*: any*/)
                    ],
                    "type": "NotifyTeamsLimitExceeded",
                    "abstractKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v44/*: any*/),
                      (v45/*: any*/),
                      (v43/*: any*/)
                    ],
                    "type": "NotifyTeamsLimitReminder",
                    "abstractKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v46/*: any*/)
                    ],
                    "type": "NotifyPromptToJoinOrg",
                    "abstractKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v7/*: any*/),
                      (v47/*: any*/),
                      (v48/*: any*/),
                      (v49/*: any*/)
                    ],
                    "type": "NotifyRequestToJoinOrg",
                    "abstractKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v7/*: any*/),
                      (v40/*: any*/),
                      (v3/*: any*/),
                      (v50/*: any*/)
                    ],
                    "type": "NotifyKudosReceived",
                    "abstractKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "UpdatedNotification",
            "kind": "LinkedField",
            "name": "UpdatedNotification",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "updatedNotification",
                "plural": false,
                "selections": [
                  (v10/*: any*/),
                  (v4/*: any*/),
                  (v11/*: any*/),
                  (v12/*: any*/),
                  (v13/*: any*/),
                  (v14/*: any*/),
                  (v15/*: any*/),
                  (v16/*: any*/),
                  (v17/*: any*/),
                  (v18/*: any*/),
                  (v19/*: any*/),
                  (v20/*: any*/),
                  (v21/*: any*/),
                  (v22/*: any*/),
                  (v23/*: any*/),
                  (v24/*: any*/),
                  (v25/*: any*/),
                  (v26/*: any*/),
                  (v51/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "RemoveIntegrationSearchQuerySuccess",
            "kind": "LinkedField",
            "name": "RemoveIntegrationSearchQuerySuccess",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "JiraServerIntegration",
                "kind": "LinkedField",
                "name": "jiraServerIntegration",
                "plural": false,
                "selections": [
                  (v55/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "PersistGitHubSearchQuerySuccess",
            "kind": "LinkedField",
            "name": "PersistGitHubSearchQuerySuccess",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "GitHubIntegration",
                "kind": "LinkedField",
                "name": "githubIntegration",
                "plural": false,
                "selections": [
                  (v57/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          (v59/*: any*/),
          (v60/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "ArchiveTimelineEventSuccess",
            "kind": "LinkedField",
            "name": "ArchiveTimelineEventSuccess",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "timelineEvent",
                "plural": false,
                "selections": [
                  (v4/*: any*/),
                  (v61/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "SetNotificationStatusPayload",
            "kind": "LinkedField",
            "name": "SetNotificationStatusPayload",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "notification",
                "plural": false,
                "selections": [
                  (v4/*: any*/),
                  (v51/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "CreateTaskPayload",
            "kind": "LinkedField",
            "name": "CreateTaskPayload",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "NotifyTaskInvolves",
                "kind": "LinkedField",
                "name": "involvementNotification",
                "plural": false,
                "selections": [
                  (v62/*: any*/),
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "NotificationTemplate_notification"
                  },
                  (v4/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "TeamMember",
                    "kind": "LinkedField",
                    "name": "changeAuthor",
                    "plural": false,
                    "selections": (v63/*: any*/),
                    "storageKey": null
                  },
                  (v64/*: any*/),
                  (v51/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Task",
                    "kind": "LinkedField",
                    "name": "task",
                    "plural": false,
                    "selections": [
                      (v4/*: any*/),
                      (v41/*: any*/),
                      (v51/*: any*/),
                      (v65/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "User",
                        "kind": "LinkedField",
                        "name": "user",
                        "plural": false,
                        "selections": (v63/*: any*/),
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          (v66/*: any*/),
          (v67/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "InviteToTeamPayload",
            "kind": "LinkedField",
            "name": "InviteToTeamPayload",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "NotificationTeamInvitation",
                "kind": "LinkedField",
                "name": "teamInvitationNotification",
                "plural": false,
                "selections": [
                  (v17/*: any*/),
                  (v4/*: any*/),
                  (v10/*: any*/),
                  (v62/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "TeamInvitation",
                    "kind": "LinkedField",
                    "name": "invitation",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "User",
                        "kind": "LinkedField",
                        "name": "inviter",
                        "plural": false,
                        "selections": (v35/*: any*/),
                        "storageKey": null
                      },
                      (v68/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "RemoveOrgUserPayload",
            "kind": "LinkedField",
            "name": "RemoveOrgUserPayload",
            "plural": false,
            "selections": [
              (v69/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "NotifyKickedOut",
                "kind": "LinkedField",
                "name": "kickOutNotifications",
                "plural": true,
                "selections": [
                  (v4/*: any*/),
                  (v10/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Team",
                    "kind": "LinkedField",
                    "name": "team",
                    "plural": false,
                    "selections": [
                      (v4/*: any*/),
                      (v7/*: any*/),
                      (v6/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v12/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          (v70/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "PersistJiraSearchQuerySuccess",
            "kind": "LinkedField",
            "name": "PersistJiraSearchQuerySuccess",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "AtlassianIntegration",
                "kind": "LinkedField",
                "name": "atlassianIntegration",
                "plural": false,
                "selections": [
                  (v71/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "PersistIntegrationSearchQuerySuccess",
            "kind": "LinkedField",
            "name": "PersistIntegrationSearchQuerySuccess",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "JiraServerIntegration",
                "kind": "LinkedField",
                "name": "jiraServerIntegration",
                "plural": false,
                "selections": [
                  (v55/*: any*/),
                  (v72/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          (v73/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "MeetingStageTimeLimitPayload",
            "kind": "LinkedField",
            "name": "MeetingStageTimeLimitPayload",
            "plural": false,
            "selections": [
              {
                "alias": "timeLimitNotification",
                "args": null,
                "concreteType": "NotificationMeetingStageTimeLimitEnd",
                "kind": "LinkedField",
                "name": "notification",
                "plural": false,
                "selections": [
                  (v18/*: any*/),
                  (v10/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "meeting",
                    "plural": false,
                    "selections": [
                      (v4/*: any*/),
                      (v7/*: any*/),
                      (v62/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "StripeFailPaymentPayload",
            "kind": "LinkedField",
            "name": "StripeFailPaymentPayload",
            "plural": false,
            "selections": [
              {
                "alias": "paymentRejectedNotification",
                "args": null,
                "concreteType": "NotifyPaymentRejected",
                "kind": "LinkedField",
                "name": "notification",
                "plural": false,
                "selections": [
                  (v10/*: any*/),
                  (v69/*: any*/),
                  (v13/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          (v76/*: any*/),
          (v77/*: any*/),
          (v78/*: any*/),
          (v79/*: any*/),
          (v80/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Subscription",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "NotificationSubscription",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "NotificationSubscriptionPayload",
        "kind": "LinkedField",
        "name": "notificationSubscription",
        "plural": false,
        "selections": [
          (v0/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "AcceptTeamInvitationPayload",
            "kind": "LinkedField",
            "name": "AcceptTeamInvitationPayload",
            "plural": false,
            "selections": [
              (v1/*: any*/),
              (v2/*: any*/),
              (v3/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "Team",
                "kind": "LinkedField",
                "name": "team",
                "plural": false,
                "selections": [
                  (v4/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "activeMeetings",
                    "plural": true,
                    "selections": [
                      (v9/*: any*/),
                      (v4/*: any*/),
                      {
                        "kind": "TypeDiscriminator",
                        "abstractKey": "__isNewMeeting"
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": null,
                        "kind": "LinkedField",
                        "name": "meetingMembers",
                        "plural": true,
                        "selections": [
                          (v9/*: any*/),
                          (v4/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "User",
                            "kind": "LinkedField",
                            "name": "user",
                            "plural": false,
                            "selections": [
                              (v4/*: any*/),
                              (v48/*: any*/),
                              (v27/*: any*/),
                              (v74/*: any*/),
                              (v75/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "lastSeenAtURLs",
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "meetingType",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "MeetingSeries",
                        "kind": "LinkedField",
                        "name": "meetingSeries",
                        "plural": false,
                        "selections": [
                          (v4/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "title",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "recurrenceRule",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "cancelledAt",
                            "storageKey": null
                          },
                          (v81/*: any*/)
                        ],
                        "storageKey": null
                      },
                      (v7/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": null,
                        "kind": "LinkedField",
                        "name": "phases",
                        "plural": true,
                        "selections": [
                          (v9/*: any*/),
                          (v29/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": null,
                            "kind": "LinkedField",
                            "name": "stages",
                            "plural": true,
                            "selections": [
                              (v9/*: any*/),
                              (v31/*: any*/),
                              (v4/*: any*/)
                            ],
                            "storageKey": null
                          },
                          (v4/*: any*/)
                        ],
                        "storageKey": null
                      },
                      (v62/*: any*/),
                      (v81/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "createdBy",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "User",
                        "kind": "LinkedField",
                        "name": "createdByUser",
                        "plural": false,
                        "selections": [
                          (v27/*: any*/),
                          (v4/*: any*/)
                        ],
                        "storageKey": null
                      },
                      (v82/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v8/*: any*/),
                  (v7/*: any*/),
                  (v83/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Organization",
                    "kind": "LinkedField",
                    "name": "organization",
                    "plural": false,
                    "selections": [
                      (v4/*: any*/),
                      (v7/*: any*/),
                      (v84/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Team",
                        "kind": "LinkedField",
                        "name": "allTeams",
                        "plural": true,
                        "selections": (v85/*: any*/),
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Team",
                        "kind": "LinkedField",
                        "name": "viewerTeams",
                        "plural": true,
                        "selections": (v85/*: any*/),
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "OrganizationFeatureFlags",
                        "kind": "LinkedField",
                        "name": "featureFlags",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "publicTeams",
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "meeting",
                "plural": false,
                "selections": [
                  (v9/*: any*/),
                  (v4/*: any*/),
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "MeetingSeries",
                        "kind": "LinkedField",
                        "name": "meetingSeries",
                        "plural": false,
                        "selections": [
                          (v4/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": null,
                            "kind": "LinkedField",
                            "name": "mostRecentMeeting",
                            "plural": false,
                            "selections": (v86/*: any*/),
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "type": "TeamPromptMeeting",
                    "abstractKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "TeamMember",
                "kind": "LinkedField",
                "name": "teamMember",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "isSelf",
                    "storageKey": null
                  },
                  (v27/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "userId",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "isLead",
                    "storageKey": null
                  },
                  {
                    "alias": "teamMemberId",
                    "args": null,
                    "kind": "ScalarField",
                    "name": "id",
                    "storageKey": null
                  },
                  (v82/*: any*/),
                  (v4/*: any*/),
                  (v48/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "User",
                    "kind": "LinkedField",
                    "name": "user",
                    "plural": false,
                    "selections": [
                      (v74/*: any*/),
                      (v4/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "User",
                "kind": "LinkedField",
                "name": "teamLead",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "suggestedActions",
                    "plural": true,
                    "selections": [
                      (v9/*: any*/),
                      {
                        "kind": "TypeDiscriminator",
                        "abstractKey": "__isSuggestedAction"
                      },
                      (v4/*: any*/),
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Team",
                            "kind": "LinkedField",
                            "name": "team",
                            "plural": false,
                            "selections": [
                              (v4/*: any*/),
                              (v7/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "TeamMember",
                                "kind": "LinkedField",
                                "name": "teamMembers",
                                "plural": true,
                                "selections": [
                                  (v47/*: any*/),
                                  (v4/*: any*/)
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "type": "SuggestedActionInviteYourTeam",
                        "abstractKey": null
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": (v87/*: any*/),
                        "type": "SuggestedActionTryRetroMeeting",
                        "abstractKey": null
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": (v87/*: any*/),
                        "type": "SuggestedActionTryActionMeeting",
                        "abstractKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  (v4/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "AddedNotification",
            "kind": "LinkedField",
            "name": "AddedNotification",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "addedNotification",
                "plural": false,
                "selections": [
                  (v9/*: any*/),
                  (v88/*: any*/),
                  (v10/*: any*/),
                  (v4/*: any*/),
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v90/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "TeamPromptMeeting",
                        "kind": "LinkedField",
                        "name": "meeting",
                        "plural": false,
                        "selections": [
                          (v4/*: any*/),
                          (v7/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": null,
                            "kind": "LinkedField",
                            "name": "phases",
                            "plural": true,
                            "selections": [
                              (v9/*: any*/),
                              (v29/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": null,
                                "kind": "LinkedField",
                                "name": "stages",
                                "plural": true,
                                "selections": (v86/*: any*/),
                                "storageKey": null
                              },
                              (v4/*: any*/)
                            ],
                            "storageKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v30/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": null,
                                "kind": "LinkedField",
                                "name": "phases",
                                "plural": true,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": null,
                                    "kind": "LinkedField",
                                    "name": "stages",
                                    "plural": true,
                                    "selections": [
                                      (v31/*: any*/),
                                      (v32/*: any*/)
                                    ],
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              }
                            ],
                            "type": "NewMeeting",
                            "abstractKey": "__isNewMeeting"
                          }
                        ],
                        "storageKey": null
                      },
                      (v92/*: any*/),
                      (v93/*: any*/),
                      (v94/*: any*/)
                    ],
                    "type": "NotifyDiscussionMentioned",
                    "abstractKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v95/*: any*/),
                      (v96/*: any*/),
                      (v94/*: any*/)
                    ],
                    "type": "NotifyKickedOut",
                    "abstractKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v98/*: any*/),
                      (v94/*: any*/)
                    ],
                    "type": "NotifyPaymentRejected",
                    "abstractKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v99/*: any*/),
                      (v64/*: any*/),
                      (v51/*: any*/),
                      (v62/*: any*/),
                      (v101/*: any*/),
                      (v102/*: any*/)
                    ],
                    "type": "NotifyTaskInvolves",
                    "abstractKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v103/*: any*/),
                      (v94/*: any*/)
                    ],
                    "type": "NotifyPromoteToOrgLeader",
                    "abstractKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v104/*: any*/),
                      (v96/*: any*/),
                      (v94/*: any*/)
                    ],
                    "type": "NotifyTeamArchived",
                    "abstractKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v105/*: any*/),
                      (v96/*: any*/),
                      (v94/*: any*/)
                    ],
                    "type": "NotificationTeamInvitation",
                    "abstractKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v106/*: any*/),
                      (v94/*: any*/)
                    ],
                    "type": "NotificationMeetingStageTimeLimitEnd",
                    "abstractKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v107/*: any*/),
                      (v37/*: any*/),
                      (v51/*: any*/),
                      (v38/*: any*/),
                      (v102/*: any*/)
                    ],
                    "type": "NotifyResponseMentioned",
                    "abstractKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v51/*: any*/),
                      (v39/*: any*/),
                      (v108/*: any*/),
                      (v38/*: any*/),
                      (v81/*: any*/),
                      (v3/*: any*/),
                      (v40/*: any*/),
                      (v109/*: any*/),
                      (v42/*: any*/)
                    ],
                    "type": "NotifyMentioned",
                    "abstractKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v90/*: any*/),
                      (v33/*: any*/),
                      (v37/*: any*/),
                      (v92/*: any*/),
                      (v94/*: any*/)
                    ],
                    "type": "NotifyResponseReplied",
                    "abstractKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v43/*: any*/),
                      (v110/*: any*/),
                      (v94/*: any*/)
                    ],
                    "type": "NotifyTeamsLimitExceeded",
                    "abstractKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v44/*: any*/),
                      (v45/*: any*/),
                      (v43/*: any*/),
                      (v110/*: any*/),
                      (v94/*: any*/)
                    ],
                    "type": "NotifyTeamsLimitReminder",
                    "abstractKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v46/*: any*/),
                      (v94/*: any*/)
                    ],
                    "type": "NotifyPromptToJoinOrg",
                    "abstractKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v7/*: any*/),
                      (v47/*: any*/),
                      (v48/*: any*/),
                      (v111/*: any*/),
                      (v49/*: any*/),
                      (v94/*: any*/)
                    ],
                    "type": "NotifyRequestToJoinOrg",
                    "abstractKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v7/*: any*/),
                      (v48/*: any*/),
                      (v40/*: any*/),
                      (v3/*: any*/),
                      (v50/*: any*/),
                      (v51/*: any*/),
                      (v102/*: any*/)
                    ],
                    "type": "NotifyKudosReceived",
                    "abstractKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "UpdatedNotification",
            "kind": "LinkedField",
            "name": "UpdatedNotification",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "updatedNotification",
                "plural": false,
                "selections": [
                  (v9/*: any*/),
                  (v88/*: any*/),
                  (v10/*: any*/),
                  (v4/*: any*/),
                  (v51/*: any*/),
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v90/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "TeamPromptMeeting",
                        "kind": "LinkedField",
                        "name": "meeting",
                        "plural": false,
                        "selections": [
                          (v4/*: any*/),
                          (v7/*: any*/),
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v30/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": null,
                                "kind": "LinkedField",
                                "name": "phases",
                                "plural": true,
                                "selections": [
                                  (v9/*: any*/),
                                  (v29/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": null,
                                    "kind": "LinkedField",
                                    "name": "stages",
                                    "plural": true,
                                    "selections": [
                                      (v9/*: any*/),
                                      (v4/*: any*/),
                                      (v31/*: any*/),
                                      (v32/*: any*/)
                                    ],
                                    "storageKey": null
                                  },
                                  (v4/*: any*/)
                                ],
                                "storageKey": null
                              }
                            ],
                            "type": "NewMeeting",
                            "abstractKey": "__isNewMeeting"
                          }
                        ],
                        "storageKey": null
                      },
                      (v92/*: any*/),
                      (v93/*: any*/),
                      (v102/*: any*/)
                    ],
                    "type": "NotifyDiscussionMentioned",
                    "abstractKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v95/*: any*/),
                      (v96/*: any*/),
                      (v102/*: any*/)
                    ],
                    "type": "NotifyKickedOut",
                    "abstractKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v98/*: any*/),
                      (v102/*: any*/)
                    ],
                    "type": "NotifyPaymentRejected",
                    "abstractKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v99/*: any*/),
                      (v64/*: any*/),
                      (v62/*: any*/),
                      (v101/*: any*/),
                      (v102/*: any*/)
                    ],
                    "type": "NotifyTaskInvolves",
                    "abstractKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v103/*: any*/),
                      (v102/*: any*/)
                    ],
                    "type": "NotifyPromoteToOrgLeader",
                    "abstractKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v104/*: any*/),
                      (v96/*: any*/),
                      (v102/*: any*/)
                    ],
                    "type": "NotifyTeamArchived",
                    "abstractKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v105/*: any*/),
                      (v96/*: any*/),
                      (v102/*: any*/)
                    ],
                    "type": "NotificationTeamInvitation",
                    "abstractKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v106/*: any*/),
                      (v102/*: any*/)
                    ],
                    "type": "NotificationMeetingStageTimeLimitEnd",
                    "abstractKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v107/*: any*/),
                      (v37/*: any*/),
                      (v38/*: any*/),
                      (v102/*: any*/)
                    ],
                    "type": "NotifyResponseMentioned",
                    "abstractKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v39/*: any*/),
                      (v108/*: any*/),
                      (v38/*: any*/),
                      (v81/*: any*/),
                      (v3/*: any*/),
                      (v40/*: any*/),
                      (v109/*: any*/),
                      (v42/*: any*/)
                    ],
                    "type": "NotifyMentioned",
                    "abstractKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v90/*: any*/),
                      (v33/*: any*/),
                      (v37/*: any*/),
                      (v92/*: any*/),
                      (v102/*: any*/)
                    ],
                    "type": "NotifyResponseReplied",
                    "abstractKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v43/*: any*/),
                      (v110/*: any*/),
                      (v102/*: any*/)
                    ],
                    "type": "NotifyTeamsLimitExceeded",
                    "abstractKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v44/*: any*/),
                      (v45/*: any*/),
                      (v43/*: any*/),
                      (v110/*: any*/),
                      (v102/*: any*/)
                    ],
                    "type": "NotifyTeamsLimitReminder",
                    "abstractKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v46/*: any*/),
                      (v102/*: any*/)
                    ],
                    "type": "NotifyPromptToJoinOrg",
                    "abstractKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v7/*: any*/),
                      (v47/*: any*/),
                      (v48/*: any*/),
                      (v111/*: any*/),
                      (v49/*: any*/),
                      (v102/*: any*/)
                    ],
                    "type": "NotifyRequestToJoinOrg",
                    "abstractKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v7/*: any*/),
                      (v48/*: any*/),
                      (v40/*: any*/),
                      (v3/*: any*/),
                      (v50/*: any*/),
                      (v102/*: any*/)
                    ],
                    "type": "NotifyKudosReceived",
                    "abstractKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "RemoveIntegrationSearchQuerySuccess",
            "kind": "LinkedField",
            "name": "RemoveIntegrationSearchQuerySuccess",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "JiraServerIntegration",
                "kind": "LinkedField",
                "name": "jiraServerIntegration",
                "plural": false,
                "selections": [
                  (v55/*: any*/),
                  (v4/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "PersistGitHubSearchQuerySuccess",
            "kind": "LinkedField",
            "name": "PersistGitHubSearchQuerySuccess",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "GitHubIntegration",
                "kind": "LinkedField",
                "name": "githubIntegration",
                "plural": false,
                "selections": [
                  (v57/*: any*/),
                  (v4/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          (v59/*: any*/),
          (v60/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "ArchiveTimelineEventSuccess",
            "kind": "LinkedField",
            "name": "ArchiveTimelineEventSuccess",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "timelineEvent",
                "plural": false,
                "selections": [
                  (v9/*: any*/),
                  (v4/*: any*/),
                  (v61/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "SetNotificationStatusPayload",
            "kind": "LinkedField",
            "name": "SetNotificationStatusPayload",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "notification",
                "plural": false,
                "selections": [
                  (v9/*: any*/),
                  (v4/*: any*/),
                  (v51/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "CreateTaskPayload",
            "kind": "LinkedField",
            "name": "CreateTaskPayload",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "NotifyTaskInvolves",
                "kind": "LinkedField",
                "name": "involvementNotification",
                "plural": false,
                "selections": [
                  (v62/*: any*/),
                  (v4/*: any*/),
                  (v99/*: any*/),
                  (v64/*: any*/),
                  (v51/*: any*/),
                  (v101/*: any*/),
                  (v102/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          (v66/*: any*/),
          (v67/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "InviteToTeamPayload",
            "kind": "LinkedField",
            "name": "InviteToTeamPayload",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "NotificationTeamInvitation",
                "kind": "LinkedField",
                "name": "teamInvitationNotification",
                "plural": false,
                "selections": [
                  (v94/*: any*/),
                  (v4/*: any*/),
                  (v105/*: any*/),
                  (v96/*: any*/),
                  (v10/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "RemoveOrgUserPayload",
            "kind": "LinkedField",
            "name": "RemoveOrgUserPayload",
            "plural": false,
            "selections": [
              (v69/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "NotifyKickedOut",
                "kind": "LinkedField",
                "name": "kickOutNotifications",
                "plural": true,
                "selections": [
                  (v4/*: any*/),
                  (v10/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Team",
                    "kind": "LinkedField",
                    "name": "team",
                    "plural": false,
                    "selections": [
                      (v4/*: any*/),
                      (v7/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": null,
                        "kind": "LinkedField",
                        "name": "activeMeetings",
                        "plural": true,
                        "selections": (v86/*: any*/),
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  (v94/*: any*/),
                  (v95/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          (v70/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "PersistJiraSearchQuerySuccess",
            "kind": "LinkedField",
            "name": "PersistJiraSearchQuerySuccess",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "AtlassianIntegration",
                "kind": "LinkedField",
                "name": "atlassianIntegration",
                "plural": false,
                "selections": [
                  (v71/*: any*/),
                  (v4/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "PersistIntegrationSearchQuerySuccess",
            "kind": "LinkedField",
            "name": "PersistIntegrationSearchQuerySuccess",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "JiraServerIntegration",
                "kind": "LinkedField",
                "name": "jiraServerIntegration",
                "plural": false,
                "selections": [
                  (v55/*: any*/),
                  (v72/*: any*/),
                  (v4/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          (v73/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "MeetingStageTimeLimitPayload",
            "kind": "LinkedField",
            "name": "MeetingStageTimeLimitPayload",
            "plural": false,
            "selections": [
              {
                "alias": "timeLimitNotification",
                "args": null,
                "concreteType": "NotificationMeetingStageTimeLimitEnd",
                "kind": "LinkedField",
                "name": "notification",
                "plural": false,
                "selections": [
                  (v94/*: any*/),
                  (v4/*: any*/),
                  (v106/*: any*/),
                  (v10/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "StripeFailPaymentPayload",
            "kind": "LinkedField",
            "name": "StripeFailPaymentPayload",
            "plural": false,
            "selections": [
              {
                "alias": "paymentRejectedNotification",
                "args": null,
                "concreteType": "NotifyPaymentRejected",
                "kind": "LinkedField",
                "name": "notification",
                "plural": false,
                "selections": [
                  (v10/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Organization",
                    "kind": "LinkedField",
                    "name": "organization",
                    "plural": false,
                    "selections": [
                      (v4/*: any*/),
                      (v7/*: any*/),
                      (v97/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v94/*: any*/),
                  (v4/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          (v76/*: any*/),
          (v77/*: any*/),
          (v78/*: any*/),
          (v79/*: any*/),
          (v80/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": "s_DCRsXgTs1mPaYHoA8xDJ3Q",
    "metadata": {},
    "name": "NotificationSubscription",
    "operationKind": "subscription",
    "text": null
  }
};
})();

(node ).hash = "c4ce5b612904b9593b5de426d578da01";

export default node;
